<template>
  <v-menu
    offset-y
    :nudge-right="40"
    :min-width="'290px'"
    :transition="'scale-transition'"
    :close-on-content-click="false"
    v-model="menu"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        dense
        hide-details
        readonly
        :value="displayValue"
        v-bind="attrs"
        v-on="on"
      >
        <template v-if="!menu" v-slot:append-outer>
          <v-icon
            class="pointer"
            :color="!clearIconHovered ? 'green' : 'red'"
            v-if="isActive"
            @mouseenter="clearIconHovered = true"
            @mouseleave="clearIconHovered = false"
            @click="clear()"
          >mdi-filter-remove</v-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      :range="isRange"
      v-model="datesValue"
    >
      <v-spacer />
      <v-btn-toggle
        v-model="modeSwitcherValue"
        mandatory
        dense
      >
        <v-btn>
          <v-icon>mdi-calendar-start</v-icon>
        </v-btn>
        <v-btn>
          <v-icon>mdi-calendar-range</v-icon>
        </v-btn>
        <v-btn>
          <v-icon>mdi-calendar-end</v-icon>
        </v-btn>
      </v-btn-toggle>
      <v-spacer />
    </v-date-picker>
  </v-menu>
</template>
<script>
import dayjs from 'dayjs'
import { smartDateFormat } from '@/utils'

const MODES = ['SINCE', 'RANGE', 'TILL']

export default {
  name: 'FilterDateRange',
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dates: [],
      menu: false,
      clearIconHovered: false,
      mode: null
    }
  },
  computed: {
    isActive () {
      return !this.menu && this.displayValue
    },
    isRange () {
      return this.mode === 'RANGE'
    },
    displayValue () {
      if (!this.dates.length) return null
      const dates = this.dates.map(date => {
        return !date ? null : smartDateFormat(date)
      })
      if (this.mode === 'SINCE') return `${dates[0]} ~`
      if (this.mode === 'TILL') return `~ ${dates[1]}`
      if (dates.length === 1) return !dates[0] ? null : `${dates[0]} ~`
      return dates.join(' ~ ')
    },
    datesValue: {
      get () {
        const datesFormatted = this.dates.map(date => dayjs(date).format('YYYY-MM-DD'))
        if (this.mode === 'SINCE') return datesFormatted[0]
        if (this.mode === 'TILL') return datesFormatted[1]
        if (!datesFormatted.length) return
        return datesFormatted
      },
      set (value) {
        if (this.mode === 'RANGE') {
          if (this.dates.length === 2) this.dates = []
          if (value.length <= 1) {
            this.dates = value
            return
          }
          const [first, second] = value
          this.dates = dayjs(first).isBefore(second) ? value : [second, first]
        } else {
          this.dates = this.mode === 'SINCE' ? [value, null] : [null, value]
        }
        this.apply(this.dates)
      }
    },
    modeSwitcherValue: {
      get () {
        return MODES.indexOf(this.mode)
      },
      set (val) {
        this.dates = []
        this.mode = MODES[val]
      }
    }
  },
  watch: {
    value (val) {
      this.populate(val)
    },
    menu (val) {
      if (!val && !this.dates.length) this.populate(this.value)
    }
  },
  methods: {
    populate ({ gte, lte }) {
      if (gte && !lte) {
        this.mode = 'SINCE'
        this.dates = [gte, null]
      } else if (!gte && lte) {
        this.mode = 'TILL'
        this.dates = [null, lte]
      } else {
        this.mode = 'RANGE'
        this.dates = gte && lte ? [gte, lte] : []
      }
    },
    apply (dates) {
      const range = dates.map((date, idx) => {
        if (!date) return null
        return !idx ? dayjs(date).startOf('day').toISOString() : dayjs(date).endOf('day').toISOString()
      })
      this.$emit('input', range)
      this.menu = false
    },
    clear () {
      this.clearIconHovered = false
      this.$emit('input', [null, null])
    }
  },
  created () {
    this.populate(this.value)
  }
}
</script>
